import { render } from "./CargoFlight.html?vue&type=template&id=3b45b0f2&ts=true&external"
import script from "./CargoFlight.vue?vue&type=script&lang=ts"
export * from "./CargoFlight.vue?vue&type=script&lang=ts"

import "./CargoFlight.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__